import { useFlags as useLaunchdarklyFlags } from 'launchdarkly-react-client-sdk';
import { useSyncExternalStore } from 'react';

import { isDev } from '~/dev/utils/isDev';

import { devFlagOverrides } from './devFlagOverrides';
import { DEV_DEFAULTS } from './flags';
import { NO_SCOPED_FLAGS, useScopedFlags } from './ScopedFlagsProvider';

export const useFlags = () => {
  const ldFlags = useLaunchdarklyFlags() ?? {};
  const overrides = useSyncExternalStore(
    devFlagOverrides.subscribe,
    devFlagOverrides.getSnapshot,
  );
  const scopedFlags = useScopedFlags();

  // In dev, flags use their configured defaults; overrides (including any LD
  // sync) take precedence. In production, use LaunchDarkly values directly.
  const flags = isDev ? { ...DEV_DEFAULTS, ...overrides } : ldFlags;
  return scopedFlags === NO_SCOPED_FLAGS ? flags : { ...flags, ...scopedFlags };
};
